var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_vm._t("default"),_c('router-link',{staticClass:"btn btn01",attrs:{"to":_vm.words.btn01.link}},[_vm._v(_vm._s(_vm.words.btn01.name))]),_c('router-link',{staticClass:"btn btn02",attrs:{"to":_vm.words.btn02.link}},[_vm._v(_vm._s(_vm.words.btn02.name))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }